/* eslint-disable react-hooks/exhaustive-deps */
import React, { useMemo, useContext, useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { useScreenSize } from "../../utils/media-query";
import DropDownButton from "devextreme-react/drop-down-button";
import Toolbar, { Item } from "devextreme-react/toolbar";
import { Switch } from "devextreme-react/switch";
import Button from "devextreme-react/button";
import { useAuth } from "../../contexts/auth";
import "./style.scss";
import {
  ColorModeContext,
  LanguageContext,
  // AnnouncementContext,
} from "../../App";
import { axios } from "../../common";
const langOptions = [
  { id: 1, value: "en", name: "English", icon: "/assets/images/flags/en.png" },
  {
    id: 2,
    value: "vi",
    name: "Tiếng Việt",
    icon: "/assets/images/flags/vi.png",
  },
  {
    id: 3,
    value: "ja",
    name: "日本語",
    icon: "/assets/images/flags/ja.png",
  },
];

export default function Header({
  menuToggleEnabled,
  toggleMenu,
  logo,
  logoDark,
}) {
  const history = useHistory();
  const { isXSmall } = useScreenSize();
  const { signOut, user } = useAuth();
  const { themeColor, changeTheme } = useContext(ColorModeContext);
  const { language, setLanguage } = useContext(LanguageContext);
  const [employee, setEmployee] = useState([]);
  const [announcement, setAnnouncement] = useState([]);
  const fetchData = async () => {
    const { data } = await axios.get("AnnouncementUser", {
      params: {
        $expand: "User,Announcement",
        $filter: "User/UserName eq '" + user.UserName + "' and IsRead eq false",
      },
    });
    setAnnouncement(data.value);
  };
  useEffect(() => {
    fetchData();
  }, []);

  const setNotificationIsRead = async (data) => {
    try {
      await axios.put(`AnnouncementUser/${data.Oid}`, data);
      history.push("/default/announcement/list");
      fetchData();
    } catch (err) {
      // console.log(err);
    }
  };
  useEffect(() => {
    // if (!user.EmployeeOid) {
    //   window.location.reload();
    //   return;
    // }
    const fetchData = async () => {
      const { data } = await axios.get(`Employee(${user?.EmployeeOid})`, {
        params: {
          $expand:
            "Department,Position($expand=Title),Alias,SeniorManager,DirectManager",
        },
      });
      setEmployee(data);
    };
    fetchData();
  }, [user]);
  const userOptions = useMemo(
    () => [
      {
        id: 1,
        icon: "home",
        title: "Home",
        onClick: () => history.push("/home"),
      },
      {
        id: 2,
        icon: "user",
        title: "Profile",
        onClick: () => {
          history.push("/default/personal-information");
        },
      },
      {
        id: 2,
        icon: "key",
        title: "Change Password",
        onClick: () => {
          history.push("/change-password");
        },
      },
      {
        id: 3,
        icon: "/assets/images/logout.png",
        title: "Logout",
        onClick: signOut,
      },
    ],
    [signOut]
  );
  const swithFlags = (lang) => {
    const object = {
      en: "/assets/images/flags/en.png",
      vi: "/assets/images/flags/vi.png",
      ja: "/assets/images/flags/ja.png",
    };
    return object[lang] ?? "/assets/images/flags/vi.png";
  };

  return (
    <header className={"header-component"}>
      <Toolbar className={"header-toolbar"}>
        <Item
          visible={menuToggleEnabled}
          location={"before"}
          widget={"dxButton"}
          cssClass={"menu-buttons"}
        >
          <Button icon="menu" stylingMode="text" onClick={toggleMenu} />
        </Item>
        <Item location={"before"} cssClass={"header-logos"}>
          <Link to="/home">
            {/* <h3 className="ml-2">ARION ELECTRIC VIET NAM CO.,LTD.</h3> */}
            <img
              src={themeColor === "light" ? logo : logoDark}
              height={isXSmall ? "40" : "40"}
              width={isXSmall ? "230" : "auto"}
              className={"ml-2"}
              alt={"logo"}
            />
          </Link>
        </Item>
        <Item
          location={"after"}
          locateInMenu={isXSmall ? "always" : "auto"}
          cssClass={"header-theme"}
        >
          {isXSmall ? null : (
            <Switch
              value={themeColor === "light" ? false : true}
              onValueChanged={() => changeTheme()}
              name="theme"
              id="switch-theme"
              switchedOnText="Dark"
              switchedOffText="Light"
              width={75}
            />
          )}
        </Item>
        <Item
          location={"after"}
          locateInMenu={isXSmall ? "always" : "auto"}
          cssClass={"header-language"}
        >
          {isXSmall ? (
            <>
              <DropDownButton
                splitButton={false}
                useSelectMode={false}
                stylingMode={"text"}
                items={langOptions}
                icon={swithFlags(language)}
                valueExpr={"id"}
                displayExpr={"name"}
                onItemClick={(e) => {
                  setLanguage(e.itemData.value);
                  window.location.reload();
                }}
                dropDownOptions={{
                  wrapperAttr: { class: "dropdown-language" },
                }}
              />
              <Button
                text="Sign out"
                type="normal"
                icon="/assets/images/logout.png"
                stylingMode="text"
                className="btn-sign-out"
                onClick={signOut}
              />
            </>
          ) : (
            <DropDownButton
              splitButton={false}
              useSelectMode={false}
              stylingMode={"text"}
              items={langOptions}
              icon={swithFlags(language)}
              valueExpr={"id"}
              displayExpr={"name"}
              onItemClick={(e) => {
                setLanguage(e.itemData.value);
                window.location.reload();
              }}
              dropDownOptions={{
                wrapperAttr: { class: "dropdown-language" },
              }}
            />
          )}
        </Item>
        <Item
          location={"after"}
          locateInMenu={isXSmall ? "always" : "auto"}
          cssClass={"header-notification"}
        >
          {isXSmall ? (
            <Button
              text="30"
              type="normal"
              icon="/assets/images/notification.png"
              stylingMode="text"
            />
          ) : (
            <DropDownButton
              splitButton={false}
              useSelectMode={false}
              stylingMode={"text"}
              items={announcement}
              icon="/assets/images/notification.png"
              valueExpr={"Oid"}
              displayExpr={"Announcement.Subject"}
              onItemClick={(e) => {
                const { itemData } = e;
                itemData.IsRead = true;
                setNotificationIsRead(itemData);
              }}
              dropDownOptions={{
                wrapperAttr: { class: "dropdown-notification" },
              }}
            />
          )}
        </Item>
        <Item
          location={"after"}
          locateInMenu={isXSmall ? "always" : "auto"}
          cssClass={"header-user"}
        >
          {isXSmall ? (
            <>
              <Button
                text={user && user.EmployeeCode}
                type="normal"
                icon="/assets/images/avatar.png"
                stylingMode="text"
              />
              <Button
                text={"Home"}
                type="normal"
                icon="home"
                onClick={() => history.push("/change-password")}
                stylingMode="text"
              />
              <Button
                text={"Change password"}
                type="normal"
                icon="key"
                onClick={() => history.push("/change-password")}
                stylingMode="text"
              />
              <Switch
                value={themeColor === "light" ? false : true}
                onValueChanged={() => changeTheme()}
                name="theme"
                id="switch-theme"
                switchedOnText="Dark"
                switchedOffText="Light"
                width={75}
              />
            </>
          ) : (
            <DropDownButton
              useSelectMode={false}
              stylingMode={"text"}
              items={userOptions}
              icon={
                employee.AvatarImage
                  ? `data:image/jpeg;base64,${employee.AvatarImage}`
                  : "/assets/images/avatar-2.png"
              }
              valueExpr={"id"}
              displayExpr={"title"}
              text={user && user.EmployeeName}
              dropDownOptions={{
                wrapperAttr: { class: "dropdown-user" },
              }}
            />
          )}
        </Item>
      </Toolbar>
    </header>
  );
}
